export default {"src":"https://fishbrain.com/_next/static/media/montana.a0a0a06e.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};